import React, { Component } from 'react';
import PropTypes from 'prop-types';
import '../App.css';

class Icon extends Component {

    constructor(props){
        super()

        this.handleClick = this.handleClick.bind(this);
    }

    componentDidMount() {
        document.addEventListener('click', this.handleClick);
    }
    
    componentWillUnmount() {
        document.removeEventListener('click', this.handleClick);
    }

    handleClick(e){
        if (this.node.contains(e.target)) {
            this.props.onClick(this.props.imageName)
        }
    }

    render() {
        return (
            <div className={"app-wrapper"} ref={node => this.node = node}>
                <div className="icon-container" >
                    <img className="icon-image" alt="" src={require('../images/' + this.props.imageName + '.png')}></img>
                </div>
            </div>
        );
    }
}

Icon.propTypes = {
    imageName: PropTypes.string,
    onClick: PropTypes.func
};


export default Icon;


// WEBPACK FOOTER //
// ./src/components/Icon.js